import React from "react"
import DatesHelper from "../../common/datesHelper";
import { Forms } from "../../common/components/CmForms";
import { CheckBox } from "../../common/components/checkBox2";
import { IAggiornaDateControlloData, PeriodDto } from "../../generated";
import { TechnicianSelector } from "../../technicians/components/TechnicianSelector";
import PeriodInput from "../../common/components/periodInput";
import Period from "../../common/period";

const { Form, FormText, FormCheck, FormDate, Submit } = Forms<IAggiornaDateControlloData>();

interface Props {
    impiantiIds: number[];
    onSubmit: (data: IAggiornaDateControlloData) => void;
}

export const AggiornaDateControlloForm: React.FunctionComponent<Props> = ({ impiantiIds, onSubmit }) => {
    const today = DatesHelper.Today();
    return (
        <Form
            onSubmit={onSubmit}
            initialValues={{
                dataUltimoControlloAnnuale: today,
                dataUltimoControlloCombustione: today,
                controlloAnnualeChecked: false,
                controlloCombustioneChecked: false,
                interventoAnnualeChecked: false,
                interventoCombustioneChecked: false,
                identificativoAnnuale: "",
                identificativoCombutione: "",
                codiceBollino: "",
                bollinoChecked: false,
            }}
        >
            {({ set, values, errors }) =>
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="mb-1">
                            <CheckBox
                                label="Effettuato controllo annuale"
                                name="controlloAnnualeChecked"
                                checked={values.controlloAnnualeChecked}
                                onChange={async checked => {
                                    await set("controlloAnnualeChecked", checked);
                                    await set("interventoAnnualeChecked", checked);
                                }}
                            />
                        </div>
                        <FormDate
                            name="dataUltimoControlloAnnuale"
                            readOnly={!values.controlloAnnualeChecked}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <FormCheck
                            name="interventoAnnualeChecked"
                            label="Crea intervento controllo annuale"
                            disabled={!values.controlloAnnualeChecked}
                        />
                        <FormText
                            name="identificativoAnnuale"
                            readOnly={!values.interventoAnnualeChecked}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="mb-1">
                            <CheckBox
                                label="Effetuato controllo combustione"
                                name="controlloCombustioneChecked"
                                checked={values.controlloCombustioneChecked}
                                onChange={async checked => {

                                    await set("controlloCombustioneChecked", checked);
                                    await set("interventoCombustioneChecked", checked);
                                }}
                            />
                        </div>
                        <FormDate
                            className="mt-1"
                            name="dataUltimoControlloCombustione"
                            readOnly={!values.controlloCombustioneChecked}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <FormCheck
                            name="interventoCombustioneChecked"
                            label="Crea intervento controllo combustione"
                            disabled={!values.controlloCombustioneChecked}
                        />
                        <FormText
                            name="identificativoCombutione"
                            readOnly={!values.interventoCombustioneChecked}
                        />
                    </div>
                    <div className="col-12">
                        <CheckBox
                            label="Bollino termico applicato (validità bollino)"
                            name="bollinochecked"
                            checked={values.bollinoChecked}
                            disabled={!values.controlloCombustioneChecked}
                            onChange={async checked => {
                                if (checked && values.bollinoValidity == null) {
                                    await set("bollinoValidity", new PeriodDto({ from: values.dataUltimoControlloCombustione!, to: DatesHelper.AddDays(values.dataUltimoControlloCombustione!, 1460) }));
                                }
                                else if (!checked && values.bollinoValidity != null) {
                                    await set("bollinoValidity", undefined);
                                }
                                await set("bollinoChecked", checked);
                            }}
                        />
                    </div>
                    <div className="col-12 mt-1">
                        <PeriodInput
                            onChange={period => set("bollinoValidity", new PeriodDto(period))}
                            disabled={!values.bollinoChecked}
                            period={values.bollinoValidity ? Period.Create(values.bollinoValidity.from, values.bollinoValidity.to) : null}
                        />
                    </div>
                    <div className="col-12 mt-1">
                        <FormText
                            label="Codice bollino"
                            name="codiceBollino"
                            disabled={!values.bollinoChecked}
                            readOnly={!values.bollinoChecked}
                        />
                    </div>
                    <div className="col-12">
                        <TechnicianSelector
                            label="Tecnico assegnato"
                            onChange={technician => set("idTechnician", technician?.id)}
                            value={values.idTechnician ?? null}
                            readonly={!values.controlloAnnualeChecked && !values.controlloCombustioneChecked}
                            error={errors.idTechnician}
                        />
                    </div>
                    <div className="col-12">
                        <Submit alwaysActive />
                    </div>
                </div>
            }
        </Form>
    )

}